import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { dateHelpers } from "@/utilities/dateHelper";
import { EngagementBaseModel } from "@/store/models/engagements/engagementBase";
import EngagementsModule from "@/store/modules/engagements.module";
import { toaster } from "@/utilities/toaster";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let EngagementList = /** @class */ (() => {
    let EngagementList = class EngagementList extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Engagements";
            this.items = [
                {
                    text: "Home",
                    href: "#",
                },
                {
                    text: "Engagements",
                    active: true,
                },
            ];
            // DATA
            this.pageIsLoading = true;
            this.showNewEngagementModal = false;
            this.tenantEngagement = new EngagementBaseModel();
        }
        metaInfo() {
            return {
                title: "SystemOne - Engagements",
            };
        }
        // EVENT WIRINGS
        openNewEngagementModal() {
            this.tenantEngagement = new EngagementBaseModel();
            this.showNewEngagementModal = true;
        }
        closeNewEngagementModal() {
            this.showNewEngagementModal = false;
        }
        // CRUD
        saveNewEngagement() {
            this.validate("newEngagementObserver").then((response) => {
                if (response) {
                    this.tenantEngagement.createdOn = new Date();
                    this.tenantEngagement.createdOnAsInputString = dateHelpers.convert(this.tenantEngagement.createdOn);
                    EngagementsModule.CreateNewEngagement(this.tenantEngagement).then((response) => {
                        this.closeNewEngagementModal();
                        toaster.ShowApiSuccess(response);
                    });
                }
            });
        }
        // COMPUTED
        get engagementLists() {
            return EngagementsModule.collection;
        }
        // LIFECYCLE
        created() {
            EngagementsModule.GetEngagements().then((response) => {
                this.pageIsLoading = false;
            });
        }
    };
    EngagementList = __decorate([
        Component({
            name: "EngagementList",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], EngagementList);
    return EngagementList;
})();
export default EngagementList;
